// extracted by mini-css-extract-plugin
module.exports = {"single":"_70b925c","resultText":"_3f8f3f4"};